import {Component, Injectable, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ForgotPasswordFormModel, Stormpath, StormpathErrorResponse} from 'angular-stormpath';
import {ReplaySubject} from 'rxjs';
import {FormErrors} from '../../../components/forms/validation/form-validator.class';
import {FormManager, FormSubmissionStatusCode} from '../../../components/forms/form-manager.class';
import {Observable} from 'rxjs/Observable';

@Component({
    template: require('./forgot-login-page.component.html'),
    styles: [require('./forgot-login-page.component.scss')]
})
@Injectable()
export class ForgotLoginPageComponent implements OnInit {
    protected forgotPasswordFormModel: ForgotPasswordFormModel;
    protected error: string | null;
    protected posting: boolean;
    protected sent: boolean;

    readonly form$ = new ReplaySubject<NgForm>(1);
    formErrors: FormErrors = {};
    private readonly _formManager: FormManager<any>;

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    constructor(public stormpath: Stormpath, fmgm: FormManager.InjectedMembers) {
        this.sent = false;
        this._formManager = new FormManager(
            fmgm,
            this.form$,
            Observable.of(() => this.stormpath.sendPasswordResetEmail(this.forgotPasswordFormModel)),
            undefined,
            false
        );
    }

    ngOnInit() {
        this.posting = false;
        this.forgotPasswordFormModel = {
            email: ''
        };
        this._formManager.displayedErrors$.subscribe(errors => this.formErrors = errors);
    }

    send(): void {
        this.posting = true;
        this.error = null;
        this._formManager.save()
            .finally(() => this.posting = false)
            .subscribe(result => {
                    if (result.status.code === FormSubmissionStatusCode.SUBMITTED) {
                        this.sent = true;
                    }
                },
                (error: StormpathErrorResponse) => this.error = error.message);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/login/forgot/forgot-login-page.component.ts